import React, { useRef } from "react";
import { IonButton, IonIcon } from "@ionic/react";
// Selectors
import { useDispatch, useSelector } from "react-redux";
import { Archive } from "../../../@types/archive";
import { addOutline } from "ionicons/icons";
import { selectItemMessageFormDataArchives } from "../../../store/paymentNoticeDetail/selectors/selectItemMessageFormDataArchives";
import createArchive from "../../../store/paymentNoticeDetail/actions/createArchive";
import { ArchiveItem } from "./ArchiveItem";

export const PaymentNoticeCommentBoxArchives: React.FC = () => {
  const fileInput = useRef(null);
  const dispatch = useDispatch();
  const onFilechange = async (event: any) => {
    await dispatch(createArchive(event.target.files[0]));
    event.target.value = null;
  };

  const archives = useSelector(selectItemMessageFormDataArchives);

  return (
    <section style={{ paddingLeft: "60px" }}>
      <input ref={fileInput} hidden type="file" onChange={onFilechange} />
      <IonButton
        color="medium"
        fill="clear"
        onClick={() => {
          // @ts-ignore
          fileInput?.current?.click();
        }}
      >
        <small>Adjuntar</small>
        <IonIcon icon={addOutline}></IonIcon>
      </IonButton>
      <section
        style={{
          display: "flex",
          scrollSnapType: "x mandatory",
          overflow: "auto",
        }}
      >
        {archives ? (
          archives.map((archive: Archive, index) => (
            <article key={index}>
              <ArchiveItem archive={archive} editable={true} />
            </article>
          ))
        ) : (
          <p>No hay adjuntos</p>
        )}
      </section>
    </section>
  );
};
